import Axios from 'axios';
import { GraphUser } from '../interfaces/GraphUser';
import { connectionFailedGroupDetails, GroupDetails } from '../interfaces/GroupDetails';
import { hasValues } from './MiscFunctions';
import { VerifiedDomain } from '../interfaces/VerifiedDomain';
import { GetFromGraph } from './GetFromRestApi';
import { IsVerbose } from './Console';

// export const getGraphToken = async (accesstoken: string): Promise<string> => {
// 	return GetGraphTokenFromBootstrap(accesstoken, false)
// 		.then(async (response) => {
// 			return response.access_token
// 		})
// 		.catch((requestError) => {
// 			IsVerbose() && console.log(requestError);
// 			IsVerbose() && console.log("error getGraphToken");
// 			return ''
// 		});
// }



export const getProfileData = async (accessToken: string): Promise<GraphUser> => {
	return GetFromGraph<GraphUser>(accessToken, "me")
		.then(async (response) => {
			return response
		})
		.catch((requestError) => {
			IsVerbose() && console.log(requestError)
			IsVerbose() && console.log("error getProfileData");
			throw requestError;
		});
};

export const getProfileDataExtended = async (accessToken: string, fields: string[], cancelToken?: import('axios').CancelToken): Promise<any> => {

	return GetFromGraph<any>(accessToken, `me?$select=${fields.join(',')}`, undefined, undefined, undefined, cancelToken)
		.then(async (response) => {
			return response
		})
		.catch((requestError) => {
			IsVerbose() && console.log(requestError)
			IsVerbose() && console.log("error getProfileData");
			throw requestError;
		});
};

export const getTenant = async (graphtoken: string): Promise<VerifiedDomain[]> => {

	return GetFromGraph<any>(graphtoken, "organization", "verifiedDomains")
		.then(async (response) => {
			return response.value?.[0]?.verifiedDomains ?? []
		})
		.catch((requestError) => {
			IsVerbose() && console.log(requestError);
			IsVerbose() && console.log("error getDomainData");
			return []
		});
};

export const getProfilePhoto = async (graphtoken: string): Promise<string> => {
	// Backend now returns base64-encoded image directly
	return GetFromGraph<string>(graphtoken, "me/photos/120x120/$value")
		.then((base64String) => {
			return base64String;
		})
		.catch((error) => {
			console.error('Error fetching profile photo:', error);
			return '';
		});
};

export const getUserPhoto = async (graphtoken: string, userId: string, cancelToken?: import('axios').CancelToken): Promise<string> => {
	// Backend now returns base64-encoded image directly
	return GetFromGraph<string>(graphtoken, `users/${userId}/photos/96x96/$value`, undefined, undefined, undefined, cancelToken)
		.then((base64String) => {
			return base64String;
		})
		.catch((error) => {
			if (Axios.isCancel(error)) { throw error; }
			console.error('Error fetching user photo:', error);
			return '';
		});
};

export async function getDomainGroups(graphtoken: string, cancelToken?: import('axios').CancelToken): Promise<GroupDetails[]> {
	let nextlink = null;
	let groups: GroupDetails[] = await GetFromGraph<any>(graphtoken, "groups?$select=id,displayName,description,resourceProvisioningOptions,createdDateTime,visibility,securityEnabled,mail", undefined, undefined, undefined, cancelToken)
		.then(async (response) => {
			nextlink = response['@odata.nextLink']
			let tempGroups: GroupDetails[] = response.value
			// IsVerbose() && console.log(nextlink)
			while (hasValues(nextlink)) {
				let moregroups: GroupDetails[] = await GetFromGraph<any>(graphtoken, nextlink.replace('https://graph.microsoft.com/v1.0/', ''), undefined, undefined, undefined, cancelToken)
					// eslint-disable-next-line no-loop-func
					.then(async (subresponse) => {
						nextlink = subresponse['@odata.nextLink'];
						return subresponse.value as GroupDetails[]
					})
					// eslint-disable-next-line no-loop-func
					.catch((requestError) => {
						if (Axios.isCancel(requestError)) { throw requestError; }
						IsVerbose() && console.log(requestError);
						nextlink = null;
						return []
					});
				// IsVerbose() && console.log(nextlink)
				tempGroups = tempGroups.concat(moregroups)
			}

			// IsVerbose() && console.log(tempGroups)
			return tempGroups
		})
		.catch((requestError) => {
			if (Axios.isCancel(requestError)) { throw requestError; }
			IsVerbose() && console.log(requestError);
			IsVerbose() && console.log("error getDomainGrops");
			return connectionFailedGroupDetails
		});
	return groups
}

export const getGroupMembers = async (graphtoken: string, groupId: string, cancelToken?: import('axios').CancelToken): Promise<GraphUser[]> => {
	if (!groupId) return [];
	return GetFromGraph<any>(graphtoken, `groups/${groupId}/members`, undefined, undefined, undefined, cancelToken)
		.then(async (response) => {
			return response.value
		})
		.catch((requestError) => {
			if (Axios.isCancel(requestError)) { throw requestError; }
			IsVerbose() && console.log(requestError);
			IsVerbose() && console.log("error getGroupMembers");
			return []
		});
};
